var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialogMask"},[_c('div',[_c('img',{attrs:{"src":require("../assets/imgs/readerCenter/dialogSuccess.png"),"alt":""}}),_c('p',[_vm._v("重置密码为："+_vm._s(_vm.value))]),_c('div',{on:{"click":_vm.close}},[_vm._v("确定")])])])}
var staticRenderFns = []

export { render, staticRenderFns }